const filesURL = import.meta.env.VITE_FILES_URL;

export const getFileUrl = (filePath?: string | null) => {
    return `${filesURL}/f/${filePath}?placeholder`;
};
